import { createSelector } from '@reduxjs/toolkit';
import { SensorTypes } from 'commons/src/models/commonEnums';
import { LocationType } from 'commons/src/models/commonTypeScript';
import { CustomThreshold } from '../../../models/thresholdModels';
import { Store } from '../../../reducers';

const selectLocations = (state: Store): LocationType[] => state.locations.locations;

export const locationCustomThresholdSelector = createSelector([selectLocations], (locations): CustomThreshold[] => {
    const validSensorKeys = Object.values(SensorTypes);

    return locations
        .filter(location => !!location.customThresholds)
        .map(location => {
            const customThresholds = location.customThresholds || {};
            const sensors = Object.keys(customThresholds).filter((key): key is SensorTypes =>
                validSensorKeys.includes(key as SensorTypes)
            );

            return {
                name: location.name,
                id: location.id,
                sensors,
            };
        });
});

export default locationCustomThresholdSelector;
